module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Usuários")])]), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.users), function(item, index) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "to": {
          name: 'UsuariosEditar',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "avatar_sem_borda usuario-avatar"
    }, [_c('img', {
      staticClass: "avatar_borda",
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.cargo))])], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "to": ({
        name: 'UsuariosAdicionar'
      })
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f7df45e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usuarios/UsuariosLista.vue
// module id = 1010
// module chunks = 1